"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renameValueLabel;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _addonsNames = _interopRequireDefault(require("./constants/addons-names"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function renameValueLabel(valKey, addonName) {
  let newValueLabel = valKey.replace(addonName, "");
  newValueLabel = (0, _addonsNames.default)(newValueLabel);
  return newValueLabel;
}